import { render, staticRenderFns } from "./campaignWhite.vue?vue&type=template&id=6e622c2f&"
import script from "./campaignWhite.vue?vue&type=script&lang=js&"
export * from "./campaignWhite.vue?vue&type=script&lang=js&"
import style0 from "./campaignWhite.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports